export const TOGGLE_AREA_ENTRY_STRATEGY = 'TOGGLE_AREA_ENTRY_STRATEGY';
export const TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS = 'TOGGLE_AREA_ENTRY_STRATEGY_SUCCESS';
export const TOGGLE_AREA_ENTRY_STRATEGY_ERROR = 'TOGGLE_AREA_ENTRY_STRATEGY_ERROR';
